import axios from 'axios'

const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '/api',
  timeout: 30000
})

request.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) config.headers.Authorization = 'Bearer ' + token
  return config
})

// 统一处理登录失效
function handleAuthExpired() {
  if (window.location.hash === '#/login') return
  localStorage.removeItem('token')
  localStorage.removeItem('currentUser')
  localStorage.removeItem('user')
  window.location.hash = '#/login'
}

request.interceptors.response.use(
  res => {
    // 拦截业务层面的 token 失效
    const data = res.data
    // 把原来的判断条件改成这样：
    if (data && data.success === false && 
       (data.msg === '请先登录' || data.msg === '登录已过期，请重新登录' || data.msg?.includes('token') || data.msg?.includes('无权限'))) {
      handleAuthExpired()
      return Promise.reject(new Error(data.msg))
    }
    return data
  },
  err => {
    console.error('请求失败', err)
    
    // 拦截 HTTP 层面的 401
    if (err.response && err.response.status === 401) {
      handleAuthExpired()
      return Promise.reject(err)
    }

    // 429 限流，返回一个带提示的响应对象，让页面正常处理
    if (err.response && err.response.status === 429) {
      const msg = err.response.data && err.response.data.msg
        ? err.response.data.msg
        : '操作过于频繁，请稍后再试'
      return Promise.resolve({ success: false, msg, code: 429 })
    }
    return Promise.reject(err)
  }
)

export default request